import { render } from "./M15-CampaignCard.vue?vue&type=template&id=56b56a84"
import script from "./M15-CampaignCard.vue?vue&type=script&lang=js"
export * from "./M15-CampaignCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__